// @ts-check
import { gql, useMutation } from '@apollo/client';

export default function useDeleteImport({ refetch }) {
  const [deleteDataImport] = useMutation(DELETE_IMPORT);

  return {
    async deleteImport(importId) {
      const { data } = await deleteDataImport({
        variables: { importId },
      });
      await refetch();
      return data?.result?.success;
    },
    /**
     * Bulk-delete: fires mutations in bounded batches and refetches once at
     * the end to avoid N redraws and to prevent an unbounded outbound spike
     * when many imports are queued. Returns { successCount, failureCount }.
     * @param {string[]} importIds
     */
    async deleteImports(importIds) {
      const CHUNK_SIZE = 5;
      let successCount = 0;
      let failureCount = 0;
      for (let i = 0; i < importIds.length; i += CHUNK_SIZE) {
        const slice = importIds.slice(i, i + CHUNK_SIZE);
        const batch = await Promise.allSettled(
          slice.map((importId) =>
            deleteDataImport({ variables: { importId } })
          )
        );
        for (const r of batch) {
          if (r.status === 'fulfilled' && r.value.data?.result?.success) {
            successCount++;
          } else {
            failureCount++;
          }
        }
      }
      await refetch();
      return { successCount, failureCount };
    },
  };
}

const DELETE_IMPORT = gql`
  mutation deleteDataImport($importId: ID!) {
    result: deleteDataImport(input: { importId: $importId }) {
      code
      success
      message
      dataImport {
        importId
      }
    }
  }
`;
